import Content from '../content';

namespace('IO.Views.Components', function (exports) {
  'use strict';

  exports.DynamicGroupForm = class DynamicGroupForm extends Content {
    initialize(options) {
      this.formTarget = options.formTarget;
      this.options = options || {};
      this.properties = [];

      this._attachEvents();
    }

    render() {
      this._detach();
      if ($('.property').length == 0) {
        this.filter();
      }
    }

    remove() {
      this.$el.off('change', '.group-selector');
    }

    /**
     * Private helper functions below
     */
    _attachEvents() {
      var filter = $.proxy(this.filter, this);

      if (!this._isValid()) {
        return;
      }

      this.$el.on('change', '.group-selector', filter);
      $(this.formTarget).on('submit', this._removeNameForeignProperties);
    }

    _removeNameForeignProperties(evt) {
      $(evt.target).find('tr.property:hidden input').removeAttr('name');
      $(evt.target).find('tr.property:hidden textarea').removeAttr('name');
    }

    _getNodeGroupProperties(callback) {
      $.ajax({
        type: 'GET',
        url: `/${currentCustomer}/node_groups/${this._getValue()}/node_properties`,
        data: {
          type: controller.replace(/s$/, ''),
          hostname: $('.current-hostname').val(),
        },
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
        },
      }).done(function (response) {
        let fields = $.parseHTML(response).filter(
            (f) => f.nodeName !== '#text' && f.classList.contains('property'),
          ),
          pattern = /Component-(?<component>\w*)/;

        Array.from($('[class^="Component-"]', fields)).forEach((f) => {
          let fieldName = pattern.exec(f.classList.value).groups.component,
            reactComponent = new window[fieldName]($(f));

          f.replaceWith(reactComponent.element[0]);
        });

        callback(fields);
      });
    }

    filter() {
      var passwordGenerator;

      if (!this._isValid()) {
        return;
      }

      this.trigger('before:filter');

      this._getNodeGroupProperties(
        function (elements) {
          $(this.formTarget).find('.property').detach();
          $(this.formTarget)
            .find('.properties-container')
            .children()
            .last()
            .append(elements);

          this.trigger('after:filter');
        }.bind(this),
      );

      passwordGenerator = new PasswordGenerator();
      passwordGenerator.destroy();
      passwordGenerator.attach();
    }

    _getValue() {
      var $selector = this.$el.find('.group-selector');

      if ($selector.is('input:checkbox')) {
        return $selector[0].checked;
      }

      return $selector.val();
    }

    _getPropertiesToShow(idx, value) {
      var inverseSelector = ':not(.ns' + value + ')',
        regularSelector = '.ns' + value,
        selector;

      selector = this.options.inverse ? inverseSelector : regularSelector;
      return $(selector);
    }

    _detach() {
      var $containers = this.$el.find('.properties-container');

      if (!this._isValid()) {
        return;
      }

      $containers.each(
        function (idx, container) {
          if (this.options.radio) {
            this.properties.push(
              $('<table></table>')
                .append(this.$el.find('.properties-source').text())
                .find('.property')
                .detach(),
            );
          } else {
            this.properties.push($(container).find('.property').detach());
          }

          this.properties[idx].show();
        }.bind(this),
      );
    }

    _isValid() {
      return (
        this.$el.find('form').length &&
        this.$el.find('.group-selector').length &&
        this.$el.find('.properties-container').length
      );
    }
  };
});
